import { GET_STUDENT_BILLINGS, GET_ALL_STUDENT_BILLINGS } from 'actions/admin/billing';

const initialState = {
  // Keyed by studentId
  billingsByStudent: {},
  // /api/student-custom-bill/batch returns a plain list, not a Spring Page
  allStudentBillings: [],
};

export default function billing(state = initialState, action = {}) {
  switch (action.type) {
    case GET_STUDENT_BILLINGS: {
      return {
        ...state,
        billingsByStudent: { ...state.billingsByStudent, [action.studentId]: action.billings },
      };
    }
    case GET_ALL_STUDENT_BILLINGS: {
      return { ...state, allStudentBillings: action.billings };
    }
    default:
      return state;
  }
}
